import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { useTheme } from '../theme/ThemeContext';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { theme, mode } = useTheme();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/', { replace: true });
    } catch {
      setError('Неверный логин или пароль');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'radial-gradient(ellipse at 50% 0%, var(--bg-sidebar) 0%, var(--bg) 70%)',
      position: 'relative',
      overflow: 'hidden',
    }}>
      <div style={{
        position: 'absolute',
        top: -200, left: '50%', transform: 'translateX(-50%)',
        width: 600, height: 600,
        borderRadius: '50%',
        background: 'radial-gradient(circle, var(--accent-dim) 0%, transparent 70%)',
        pointerEvents: 'none',
      }} />
      <form
        onSubmit={handleSubmit}
        style={{
          background: 'var(--bg-card)',
          border: '1px solid var(--border)',
          borderRadius: 20,
          padding: '44px 40px 36px',
          width: 400,
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          boxShadow: 'var(--shadow-lg)',
          animation: 'fadeIn .4s ease-out',
          position: 'relative',
          zIndex: 1,
        }}
      >
        <img
          src={mode === 'light' ? '/dasna_logo_black.png' : '/dasna_logo_white.png'}
          alt="DASNA"
          style={{ maxWidth: '70%', height: 'auto', objectFit: 'contain', alignSelf: 'center' }}
        />
        <p style={{
          color: 'var(--text-muted)',
          textAlign: 'center',
          margin: '0 0 8px',
          fontSize: 13,
          letterSpacing: 0.3,
          fontFamily: theme.fontDisplay,
        }}>
          Аналитическая платформа
        </p>
        {error && <div className="error-state">{error}</div>}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <label style={{ color: 'var(--text-secondary)', fontSize: 12, fontWeight: 600, letterSpacing: 0.4 }}>Логин</label>
          <input
            style={{
              background: 'var(--bg-input)',
              border: '1px solid var(--border)',
              borderRadius: 10,
              padding: '12px 16px',
              color: 'var(--text-primary)',
              fontSize: 14,
              outline: 'none',
            }}
            placeholder="Введите логин"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoFocus
          />
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <label style={{ color: 'var(--text-secondary)', fontSize: 12, fontWeight: 600, letterSpacing: 0.4 }}>Пароль</label>
          <input
            style={{
              background: 'var(--bg-input)',
              border: '1px solid var(--border)',
              borderRadius: 10,
              padding: '12px 16px',
              color: 'var(--text-primary)',
              fontSize: 14,
              outline: 'none',
            }}
            type="password"
            placeholder="Введите пароль"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button
          style={{
            background: 'var(--accent)',
            color: theme.mode === 'light' ? '#fff' : '#041016',
            border: 'none',
            borderRadius: 10,
            padding: '13px 0',
            fontSize: 15,
            fontWeight: 700,
            fontFamily: theme.fontDisplay,
            cursor: loading ? 'wait' : 'pointer',
            opacity: loading ? 0.75 : 1,
          }}
          type="submit"
          disabled={loading}
          onMouseEnter={(e) => { if (!loading) e.currentTarget.style.background = 'var(--accent-hover)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = 'var(--accent)'; }}
        >
          {loading ? 'Вход...' : 'Войти'}
        </button>
      </form>
    </div>
  );
}
